var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageUrl)?_c('v-img',{attrs:{"src":_vm.imageUrl,"aspect-ratio":"1","max-height":"100","max-width":"200"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }